module.exports = __webpack_public_path__ + "static/media/mute.6eab49d8.svg";